<template>
  <v-container>
    <v-card>
      <v-card-title>Monitoring</v-card-title>
      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-center">
                  Assyst
                </th>
                <th class="text-center">
                  Reports
                </th>
                <th class="text-center">
                  Search
                </th>
                <th class="text-center">
                  Chat
                </th>
                <th class="text-center">
                  Assyst AI
                </th>
                <th class="text-center">
                  iPaaS
                </th>
                <th class="text-center">
                  ActiveMQ
                </th>
                <th
                  v-if="contract.itom_url !== null"
                  class="text-center"
                >
                  ITOM
                </th>
                <th class="text-center">
                  URL
                </th>
                <th class="text-center">
                  Ping
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-center">
                  <v-icon>
                    {{ getMonitoringIcon(contract.monitor_assyst) }}
                  </v-icon>
                </td>
                <td class="text-center">
                  <v-icon>
                    {{ getMonitoringIcon(contract.monitor_reports) }}
                  </v-icon>
                </td>
                <td class="text-center">
                  <v-icon>
                    {{ getMonitoringIcon(contract.monitor_search) }}
                  </v-icon>
                </td>
                <td class="text-center">
                  <v-icon>
                    {{ getMonitoringIcon(contract.monitor_chat) }}
                  </v-icon>
                </td>
                <td class="text-center">
                  <v-icon>
                    {{ getMonitoringIcon(contract.monitor_assystai) }}
                  </v-icon>
                </td>
                <td class="text-center">
                  <v-icon>
                    {{ getMonitoringIcon(contract.monitor_ipaas) }}
                  </v-icon>
                </td>
                <td class="text-center">
                  <v-icon>
                    {{ getMonitoringIcon(contract.monitor_activemq) }}
                  </v-icon>
                </td>
                <td
                  v-if="contract.itom_url !== null"
                  class="text-center"
                >
                  <v-icon>
                    {{ getMonitoringIcon(contract.monitor_itom) }}
                  </v-icon>
                </td>
                <td class="text-center">
                  <v-icon>
                    {{ getMonitoringIcon(contract.monitor_url) }}
                  </v-icon>
                </td>
                <td class="text-center">
                  <v-icon>
                    {{ getMonitoringIcon(contract.monitor_ping) }}
                  </v-icon>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions
        v-if="userHasPermission('edit_contract') && adminToggle"
      >
        <v-spacer />
        <v-dialog
          v-model="editDialog"
          persistent
          width="500"
        >
          <template v-slot:activator="{ on: dialog, attrs }">
            <v-tooltip
              top
              color="primary"
            >
              <template v-slot:activator="{ on: tooltip }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="{ ...tooltip, ...dialog }"
                >
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Edit Monitoring</span>
            </v-tooltip>
          </template>
          <v-card>
            <v-card-title class="text-h5 accent lighten-2">
              Edit monitoring
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-switch
                      v-model="monitorAssyst"
                      label="Monitor assyst"
                    />
                    <v-switch
                      v-model="monitorReports"
                      label="Monitor reports"
                    />
                    <v-switch
                      v-model="monitorSearch"
                      label="Monitor search"
                    />
                    <v-switch
                      v-model="monitorChat"
                      label="Monitor chat"
                    />
                    <v-switch
                      v-model="monitorAssystAI"
                      label="Monitor assyst AI"
                    />
                    <v-switch
                      v-model="monitorIpaas"
                      label="Monitor ipaas"
                    />
                    <v-switch
                      v-model="monitorActiveMQ"
                      label="Monitor activeMQ"
                    />
                    <v-switch
                      v-if="contract.itom_url !== null"
                      v-model="monitorITOM"
                      label="Monitor itom"
                    />
                    <v-switch
                      v-model="monitorUrl"
                      label="Monitor URL"
                    />
                    <v-switch
                      v-model="monitorPing"
                      label="Monitor Ping"
                    />
                    <v-spacer />
                    <v-btn
                      color="accent"
                      @click="toggleAllMonitors()"
                    >
                      SELECT/DESELECT ALL
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-divider />

            <v-card-actions>
              <v-spacer />
              <v-btn
                text
                @click="cancelEdit()"
              >
                CANCEL
              </v-btn>
              <v-btn
                color="accent"
                @click="updateContract()"
              >
                SAVE
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import { authHeader } from '@/util/helpers'
  import getEnv from '@/util/env'
  import { get, sync } from 'vuex-pathify'
  const host = getEnv('VUE_APP_API_HOST')
  export default {
    name: 'ContractMonitoring',
    props: {
      contract: Object,
    },
    data () {
      return {
        editDialog: false,
        toggleAll: false,
        monitorAssyst: this.contract.monitor_assyst === 'y',
        monitorITOM: this.contract.monitor_itom === 'y',
        monitorReports: this.contract.monitor_reports === 'y',
        monitorChat: this.contract.monitor_chat === 'y',
        monitorSearch: this.contract.monitor_search === 'y',
        monitorIpaas: this.contract.monitor_ipaas === 'y',
        monitorActiveMQ: this.contract.monitor_activemq === 'y',
        monitorUrl: this.contract.monitor_url === 'y',
        monitorPing: this.contract.monitor_ping === 'y',
        monitorAssystAI: this.contract.monitor_assystai === 'y',
      }
    },
    computed: {
      ...sync('app', [
        'adminToggle',
      ]),
      ...get('user', [
        'user',
      ]),
      contractData () {
        const fields = {
          monitor_assyst: this.monitorAssyst === true ? 'y' : 'n',
          monitor_reports: this.monitorReports === true ? 'y' : 'n',
          monitor_search: this.monitorSearch === true ? 'y' : 'n',
          monitor_chat: this.monitorChat === true ? 'y' : 'n',
          monitor_ipaas: this.monitorIpaas === true ? 'y' : 'n',
          monitor_activemq: this.monitorActiveMQ === true ? 'y' : 'n',
          monitor_url: this.monitorUrl === true ? 'y' : 'n',
          monitor_ping: this.monitorPing === true ? 'y' : 'n',
          monitor_assystai: this.monitorAssystAI === true ? 'y' : 'n',
        }

        if (this.hasItom !== null) {
          fields.monitor_itom = this.monitorITOM === true ? 'y' : 'n'
        }
        return fields
      },
    },
    methods: {
      userHasPermission: function (perm) {
        let perms = this.user.permissions.map(a => a.name)
        return perms.includes(perm)
      },
      getMonitoringIcon: function (monitorState) {
        if (monitorState === 'y') {
          return 'mdi-check-circle'
        } else {
          return 'mdi-close-circle'
        }
      },
      toggleAllMonitors: function () {
        this.monitorAssyst = !this.toggleAll
        this.monitorReports = !this.toggleAll
        this.monitorSearch = !this.toggleAll
        this.monitorChat = !this.toggleAll
        this.monitorITOM = !this.toggleAll
        this.monitorIpaas = !this.toggleAll
        this.monitorActiveMQ = !this.toggleAll
        this.monitorUrl = !this.toggleAll
        this.monitorPing = !this.toggleAll
        this.monitorAssystAI = !this.toggleAll
        this.toggleAll = !this.toggleAll
      },
      cancelEdit: function () {
        // This section wasn't actually doing anything. Left as comment in case it needs reworked
        // this.monitorAssyst = this.monitorWebProp === 'y'
        // this.monitorITOM = this.monitorItomProp === 'y'
        // this.monitorReports = this.monitorReportsProp === 'y'
        // this.monitorChat = this.monitorChatProp === 'y'
        // this.monitorSearch = this.monitorSearchProp === 'y'
        // this.monitorIpaas = this.monitorIpaasProp === 'y'
        // this.monitorActiveMQ = this.monitorActiveMqProp === 'y'
        // this.monitorUrl = this.monitorUrlProp === 'y'
        // this.monitorPing = this.monitorPingProp === 'y'
        this.editDialog = false
      },
      updateContract: function () {
        axios
          .put(
            `${host}/v2/contracts/` + this.$route.params.id,
            this.contractData,
            {
              headers: authHeader(),
            },
          ) // eslint-disable-next-line
          .then((response) => {
            this.$snackbar.showMessage({ content: 'Contract monitoring has been updated.', color: 'success', timeout: 5000 })
            this.editDialog = false
            setTimeout(() => this.$emit('updateContract'), 1000)
          })
          .catch(() => {
            this.$errordialog.showMessage({ content: 'There was an error, please try again.', color: 'error', title: 'Oops! Something went wrong.' })
            this.editDialog = false
          })
      },
    },
  }
</script>
